(function () {
  'use strict';

  if (window.PrewornCartDrawerLoaded) return;
  window.PrewornCartDrawerLoaded = true;

  var root;
  var panel;
  var body;
  var footer;
  var notice;
  var cartState = null;
  var lastFocused = null;
  var requestInProgress = null;

  function routesPath(name, fallback) {
    return window.routes && window.routes[name] ? window.routes[name] : fallback;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function safeUrl(value, fallback) {
    var raw = String(value || '').trim();
    if (/^(?:https?:)?\/\//i.test(raw) || raw.charAt(0) === '/') return raw;
    return fallback || '#';
  }

  function money(cents, currency) {
    var amount = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: currency || 'GBP'
      }).format(amount);
    } catch (error) {
      return '£' + amount.toFixed(2);
    }
  }

  function itemHandle(item) {
    if (item && item.handle) return String(item.handle);
    var url = String(item && item.url || '');
    var match = url.match(/\/products\/([^/?#]+)/i);
    return match ? decodeURIComponent(match[1]) : String(item && item.product_id || '');
  }

  function imageUrl(item) {
    var image = item && item.featured_image;
    if (image && image.url) return safeUrl(image.url, '');
    if (image && image.src) return safeUrl(image.src, '');
    return safeUrl(item && item.image, '');
  }

  function tierPrice(cents) {
    var original = Math.max(0, Number(cents) || 0);
    var percent = 55;
    var multiplier = .45;

    if (original <= 0) {
      return { original: 0, current: 0, percent: 0 };
    }

    if (original <= 500) {
      percent = 10;
      multiplier = .90;
    } else if (original <= 1000) {
      percent = 20;
      multiplier = .80;
    } else if (original <= 1500) {
      percent = 30;
      multiplier = .70;
    } else if (original <= 2000) {
      percent = 40;
      multiplier = .60;
    } else if (original < 3000) {
      percent = 45;
      multiplier = .55;
    }

    return {
      original: original,
      current: Math.round(original * multiplier),
      percent: percent
    };
  }

  function allocatedBuyGetSaving(item) {
    var allocations = Array.isArray(item.line_level_discount_allocations)
      ? item.line_level_discount_allocations : [];
    var saving = 0;

    for (var i = 0; i < allocations.length; i++) {
      var application = allocations[i].discount_application || {};
      var title = String(application.title || application.description || '');
      if (/buy\s*2|2\s*,?\s*get\s*1|buy.*get.*free/i.test(title)) {
        saving += Number(allocations[i].amount) || 0;
      }
    }

    return saving;
  }

  function pricingBreakdown(item) {
    var quantity = Math.max(1, Number(item.quantity) || 1);
    var originalLine = Number(item.original_line_price || 0);
    var originalUnit = Number(item.original_price || 0) || Math.round(originalLine / quantity);
    var tier = tierPrice(originalUnit);
    var prpLine = originalLine || tier.original * quantity;
    var standardLine = tier.current * quantity;
    var finalLine = item.final_line_price != null
      ? Number(item.final_line_price)
      : item.line_price != null
        ? Number(item.line_price)
        : Number(item.final_price || 0) * quantity;
    var inferredOfferSaving = Math.max(0, standardLine - finalLine);

    return {
      originalLine: prpLine,
      standardLine: standardLine,
      finalLine: finalLine,
      prpSaving: Math.max(0, prpLine - standardLine),
      offerSaving: allocatedBuyGetSaving(item) || inferredOfferSaving,
      percent: tier.percent
    };
  }

  function cartItemKey(item) {
    return String(item && (item.key || item.id) || '');
  }

  function offerItemStates(items) {
    var states = {};
    var freeSlots = Math.floor(items.length / 3);
    var confirmed = 0;
    var candidates = [];

    for (var i = 0; i < items.length; i++) {
      var pricing = pricingBreakdown(items[i]);
      var key = cartItemKey(items[i]);
      if (!key || pricing.standardLine <= 0) continue;

      if (pricing.finalLine <= 0 || pricing.offerSaving >= pricing.standardLine) {
        states[key] = { free: true, confirmed: true };
        confirmed++;
      } else {
        candidates.push({
          key: key,
          price: pricing.standardLine,
          position: i
        });
      }
    }

    var projected = Math.max(0, freeSlots - confirmed);
    candidates.sort(function (left, right) {
      return left.price - right.price || left.position - right.position;
    });
    for (var j = 0; j < projected && j < candidates.length; j++) {
      states[candidates[j].key] = { free: true, confirmed: false };
    }

    return states;
  }

  function itemMarkup(item, offerState) {
    var title = String(item.product_title || item.title || 'One-off piece');
    var vendor = String(item.vendor || 'PREWORN');
    var variant = String(item.variant_title || '').replace(/^Default Title$/i, '');
    var url = safeUrl(item.url, '#');
    var image = imageUrl(item);
    var pricing = pricingBreakdown(item);
    var original = pricing.originalLine;
    var finalPrice = pricing.finalLine;
    var discount = pricing.percent;
    var key = String(item.key || item.id || '');
    var isFree = finalPrice === 0 || !!(offerState && offerState.free);
    var isConfirmedFree = finalPrice === 0 || (isFree && offerState.confirmed);
    var isProjectedFree = isFree && !isConfirmedFree;
    var freePrice = pricing.standardLine || finalPrice || original;
    var displayedPrice = isProjectedFree ? freePrice : finalPrice;
    var imageMarkup = image
      ? '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(title) + '" loading="lazy">'
      : '<span class="pwcart__media-empty">PREWORN</span>';

    return (
      '<li class="pwcart__item' + (isFree ? ' pwcart__item--free' : '') +
        (isProjectedFree ? ' pwcart__item--free-pending' : '') + '" data-pw-cart-item="' + escapeHtml(key) + '">' +
        '<a class="pwcart__media" href="' + escapeHtml(url) + '" aria-label="View ' + escapeHtml(title) + '">' +
          imageMarkup +
          (isFree
            ? '<span class="pwcart__discount pwcart__discount--free" aria-label="' +
              (isConfirmedFree ? 'Free item' : 'Free at checkout') + '">FREE</span>'
            : discount > 0
            ? '<span class="pwcart__discount pwcart__discount--' + discount + '">' + discount + '%<br>OFF</span>'
            : '') +
        '</a>' +
        '<div class="pwcart__details">' +
          '<p class="pwcart__vendor">' + escapeHtml(vendor) + '</p>' +
          '<a class="pwcart__title" href="' + escapeHtml(url) + '">' + escapeHtml(title) + '</a>' +
          (variant ? '<p class="pwcart__variant">' + escapeHtml(variant) + '</p>' : '') +
          '<span class="pwcart__one-off' + (isFree ? ' is-free' : '') + '"' +
            (isProjectedFree ? ' title="Free item applied at checkout"' : '') + '>' +
            (isFree ? 'FREE' : 'ONE OF ONE') +
          '</span>' +
          '<div class="pwcart__price">' +
            (original > displayedPrice
              ? '<s>' + money(original, cartState && cartState.currency) + '</s>' : '') +
            '<strong' + (isConfirmedFree ? ' class="is-free"' : '') + '>' +
              (isProjectedFree ? money(freePrice, cartState && cartState.currency) : finalPrice === 0 ? 'FREE' : money(finalPrice, cartState && cartState.currency)) +
            '</strong>' +
          '</div>' +
          (pricing.prpSaving > 0
            ? '<p class="pwcart__item-saving">Save ' + money(pricing.prpSaving, cartState && cartState.currency) + ' off PRP</p>'
            : '') +
          (pricing.offerSaving > 0
            ? '<p class="pwcart__item-offer-saving">Buy 2, Get 1 Free: -' + money(pricing.offerSaving, cartState && cartState.currency) + '</p>'
            : '') +
        '</div>' +
        '<button class="pwcart__remove" type="button" data-pw-cart-remove="' + escapeHtml(key) + '" aria-label="Remove ' + escapeHtml(title) + ' from basket" title="Remove from basket">' +
          '<svg aria-hidden="true" viewBox="0 0 24 24"><path d="m7 7 10 10M17 7 7 17"></path></svg>' +
        '</button>' +
      '</li>'
    );
  }

  function emptyMarkup() {
    return (
      '<div class="pwcart__empty">' +
        '<div class="pwcart__empty-mark" aria-hidden="true">' +
          '<svg viewBox="0 0 24 24"><path d="M5.5 8.5h13l1 12h-15l1-12Z"></path><path d="M9 9V6.5a3 3 0 0 1 6 0V9"></path></svg>' +
        '</div>' +
        '<h3>Your bag is empty.</h3>' +
        '<p>Your next one-off find could disappear at any moment. Save it before somebody else does.</p>' +
        '<a href="/collections/new-in">SHOP NEW IN <span aria-hidden="true">↗</span></a>' +
      '</div>'
    );
  }

  function updateHeaderCount(count) {
    var link = document.getElementById('cart-icon-bubble');
    if (!link) return;

    var badge = link.querySelector('.pw-header-cart-count');
    if (count > 0 && !badge) {
      badge = document.createElement('span');
      badge.className = 'pw-header-cart-count';
      badge.setAttribute('aria-hidden', 'true');
      link.appendChild(badge);
    }
    if (badge) {
      badge.textContent = count < 100 ? String(count) : '99+';
      badge.hidden = count < 1;
    }
    link.setAttribute('aria-label', 'Bag' + (count ? ', ' + count + (count === 1 ? ' item' : ' items') : ''));
  }

  function dispatchCartChange(cart) {
    if (typeof window.CustomEvent !== 'function') return;
    window.dispatchEvent(new CustomEvent('preworn:cart-change', {
      detail: { cart: cart }
    }));
  }

  function showNotice(message) {
    if (!notice) return;
    notice.textContent = message || '';
    notice.hidden = !message;
  }

  function renderOfferProgress(itemCount) {
    var status = root.querySelector('[data-pw-cart-offer-status]');
    var progress = root.querySelector('[data-pw-cart-offer-progress]');
    var groups = Math.floor(itemCount / 3);
    var remainder = itemCount % 3;
    var remaining = remainder === 0 ? 3 : 3 - remainder;
    var message;

    if (groups > 0) {
      message = groups + ' free ' + (groups === 1 ? 'piece' : 'pieces') + ' unlocked';
      if (remainder > 0) {
        message += ' · add ' + remaining + ' more for another';
      } else {
        message += ' · confirmed at checkout';
      }
    } else {
      message = 'Add ' + remaining + ' more ' + (remaining === 1 ? 'piece' : 'pieces') + ' to unlock a free one';
    }

    if (status) status.textContent = message + '.';
    if (!progress) return;
    var marks = progress.querySelectorAll('i');
    var filled = groups > 0 && remainder === 0 ? 3 : remainder;
    for (var i = 0; i < marks.length; i++) {
      marks[i].classList.toggle('is-filled', i < filled);
      marks[i].classList.toggle('is-free', i === 2 && filled === 3);
    }
  }

  function cartSavings(items) {
    var totals = { prp: 0, offer: 0 };
    for (var i = 0; i < items.length; i++) {
      var pricing = pricingBreakdown(items[i]);
      totals.prp += pricing.prpSaving;
      totals.offer += pricing.offerSaving;
    }
    return totals;
  }

  function render(cart) {
    cartState = cart || { items: [], item_count: 0, total_price: 0 };
    var items = Array.isArray(cartState.items) ? cartState.items : [];
    var countTarget = root.querySelector('[data-pw-cart-count]');
    var subtotal = root.querySelector('[data-pw-cart-subtotal]');
    var prpSavingRow = root.querySelector('[data-pw-cart-prp-saving-row]');
    var prpSavingTarget = root.querySelector('[data-pw-cart-prp-saving]');
    var offerSavingRow = root.querySelector('[data-pw-cart-offer-saving-row]');
    var offerSavingTarget = root.querySelector('[data-pw-cart-offer-saving]');
    var savingRow = root.querySelector('[data-pw-cart-saving-row]');
    var savingTarget = root.querySelector('[data-pw-cart-saving]');
    var originalTotal = Number(cartState.original_total_price || cartState.total_price || 0);
    var total = Number(cartState.total_price || 0);
    var saving = Math.max(0, originalTotal - total);
    var savingParts = cartSavings(items);
    var offerStates = offerItemStates(items);

    if (countTarget) countTarget.textContent = '(' + (Number(cartState.item_count) || 0) + ')';
    updateHeaderCount(Number(cartState.item_count) || 0);
    renderOfferProgress(items.length);

    if (!items.length) {
      body.innerHTML = emptyMarkup();
      footer.hidden = true;
    } else {
      body.innerHTML = '<ul class="pwcart__list">' + items.map(function (item) {
        return itemMarkup(item, offerStates[cartItemKey(item)] || null);
      }).join('') + '</ul>';
      footer.hidden = false;
      if (subtotal) subtotal.textContent = money(total, cartState.currency);
      if (prpSavingRow) prpSavingRow.hidden = savingParts.prp <= 0;
      if (prpSavingTarget) prpSavingTarget.textContent = '-' + money(savingParts.prp, cartState.currency);
      if (offerSavingRow) offerSavingRow.hidden = savingParts.offer <= 0;
      if (offerSavingTarget) offerSavingTarget.textContent = '-' + money(savingParts.offer, cartState.currency);
      if (savingRow) savingRow.hidden = saving <= 0;
      if (savingTarget) savingTarget.textContent = money(saving, cartState.currency);
    }

    showNotice('');
    dispatchCartChange(cartState);
    return cartState;
  }

  function request(url, options) {
    return window.fetch(url, options).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || 'Your basket could not be updated.');
        }
        return data;
      });
    });
  }

  function uniquenessUpdates(cart) {
    var seen = {};
    var updates = {};
    var items = cart && Array.isArray(cart.items) ? cart.items : [];

    for (var i = 0; i < items.length; i++) {
      var handle = itemHandle(items[i]);
      var key = String(items[i].key || items[i].id || '');
      if (!key) continue;

      if (seen[handle]) {
        updates[key] = 0;
      } else {
        seen[handle] = true;
        if (Number(items[i].quantity) !== 1) updates[key] = 1;
      }
    }

    return updates;
  }

  function postUpdates(updates) {
    return request(routesPath('cart_update_url', '/cart/update.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates: updates })
    });
  }

  function enforceUniqueness(cart) {
    var updates = uniquenessUpdates(cart);
    return Object.keys(updates).length ? postUpdates(updates) : Promise.resolve(cart);
  }

  function openDrawer() {
    if (!root) return;
    lastFocused = document.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('pwcart-is-open');
    window.requestAnimationFrame(function () {
      var close = root.querySelector('.pwcart__close');
      if (close) close.focus();
    });
  }

  function closeDrawer() {
    if (!root) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('pwcart-is-open');
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  function refresh(openAfter) {
    if (requestInProgress) {
      return requestInProgress.then(function (cart) {
        if (openAfter) openDrawer();
        return cart;
      });
    }

    requestInProgress = request(routesPath('cart_url', '/cart') + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(enforceUniqueness).then(render).then(function (cart) {
      if (openAfter) openDrawer();
      return cart;
    }).catch(function (error) {
      showNotice(error && error.message ? error.message : 'Your basket could not be loaded.');
      throw error;
    }).finally(function () {
      requestInProgress = null;
    });

    return requestInProgress;
  }

  function update(updates, openAfter) {
    showNotice('');
    requestInProgress = postUpdates(updates).then(enforceUniqueness).then(render).then(function (cart) {
      if (openAfter) openDrawer();
      return cart;
    }).catch(function (error) {
      showNotice(error && error.message ? error.message : 'Your basket could not be updated.');
      throw error;
    }).finally(function () {
      requestInProgress = null;
    });
    return requestInProgress;
  }

  function removeItem(button) {
    var key = button.getAttribute('data-pw-cart-remove');
    if (!key || button.classList.contains('is-loading')) return;
    button.classList.add('is-loading');
    button.disabled = true;
    var updates = {};
    updates[key] = 0;
    update(updates, true).catch(function () {
      button.classList.remove('is-loading');
      button.disabled = false;
    });
  }

  function bindProductFormShim() {
    var shim = document.querySelector('.pwcart__product-form-shim');
    if (!shim) return;
    shim.getSectionsToRender = function () { return []; };
    shim.renderContents = function () { refresh(true); };
    shim.setActiveElement = function (element) { lastFocused = element; };
  }

  function boot() {
    root = document.querySelector('[data-pw-cart-drawer]');
    if (!root) return;
    panel = root.querySelector('.pwcart__panel');
    body = root.querySelector('[data-pw-cart-body]');
    footer = root.querySelector('[data-pw-cart-footer]');
    notice = root.querySelector('[data-pw-cart-notice]');

    window.PrewornCart = {
      refresh: refresh,
      update: update,
      open: openDrawer,
      close: closeDrawer,
      getState: function () { return cartState; }
    };

    bindProductFormShim();

    document.addEventListener('click', function (event) {
      var close = event.target.closest('[data-pw-cart-close]');
      if (close) {
        event.preventDefault();
        closeDrawer();
        return;
      }

      var remove = event.target.closest('[data-pw-cart-remove]');
      if (remove) {
        event.preventDefault();
        removeItem(remove);
        return;
      }

      var cartLink = event.target.closest('#cart-icon-bubble');
      if (cartLink) {
        event.preventDefault();
        refresh(true).catch(function () {});
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && root.classList.contains('is-open')) closeDrawer();
    });

    refresh(false).catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
